import { Icon, Modal, Box } from "@mui/material";
import { Clear as ClearIcon } from "@mui/icons-material";

const InfoV2 = ({ children, open, handleClose, sxExtra }) => {
  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
      }}
      slotProps={{
        root: {},
        backdrop: {
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        },
      }}
    >
      <Box
        sx={{
          // width: '400px',
          mixWidth: "md",
          position: "absolute",
          // width: '80%',
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#fff",
          padding: "30px",
          borderRadius: "20px",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          "&:focus": {
            outline: "none",
          },
          ...sxExtra,
        }}
      >
        <Icon
          onClick={() => {
            handleClose();
          }}
          sx={{
            "&:hover": {
              cursor: "pointer",
              backgroundColor: "#e3e3e3",
              color: "#fff",
            },
            p: "5px",
            backgroundColor: "#eee",
            borderRadius: "50%",
            zIndex: 1,
            position: "absolute",
            top: "10px",
            right: "10px",
          }}
        >
          <ClearIcon />
        </Icon>
        {children}
      </Box>
    </Modal>
  );
};

export default InfoV2;
